import React, {useEffect, useState} from 'react'
import {connect} from 'react-redux'
import {alertActions, contracterActions} from '../../../store/actions'
import PopupAddTax from "../PopupAddTax";
import history from "../../../route/history";
import moment from "moment";
import {commons} from "../../../hook/common";

/**
 * 구매확인서 4단계 / 세금계산서 정보
 */
const CertificateStep04 = props => {
  const [ docid, setDocid] = useState();
  const [ taxList, setTaxList] = useState(props.stepData);
  const [ showAddTax, setShowAddTax] = useState(false);

  /**
   * 페이지 진입
   */
  useEffect(() => {
    let id = props.search?.split("=")[1];
    let key =  props.search?.split("=")[0];

    if (id && key === '?id') {
      let data = JSON.parse(sessionStorage.getItem(id));

      //이전 페이지 정보가 없을 경우 첫 화면으로 이동
      if (!data || data?.step3?.length <= 0) {
        history.replace('/service/apply/1?id='+ id);
        return;
      }

      setDocid(id);
      setTaxList(data.step4);

    } else {
      history.replace('/service/apply/1');
    }
  }, [])

  /**
   * 데이터 갱신
   */
  useEffect(() => {

    if (props.isCalled === true) {
      setTaxList(props.stepData);
    }
    props.setCalled(false);

  }, [props?.isCalled])

  return (
      <React.Fragment>
        {showAddTax &&  <PopupAddTax
            onClose={() => setShowAddTax(false)}
            docid={docid}
        />}

        <div className="step-title m-t-20 m-b-10">
            세금계산서 정보
            <span>(외화획득용 원료·기재를 구매한 자가 신청하는 경우에만 해당)</span>
        </div>
        <div className="title-btn m-t-20">
            <div className="dis-flex ">
                <span className="totalPage w-50">총 {taxList?.length}건</span>
                <div className="flex-r w-50">
                    <button className="btn btn-white" onClick={() => setShowAddTax(true)}>세금계산서 등록/수정</button>
                </div>
            </div>
        </div>
        <div className="table">
          <div className="row header border">
            <div className="cell w-10">세금계산서 번호</div>
            <div className="cell w-10">품명</div>
            <div className="cell w-10">규격</div>
            <div className="cell w-10">공금가액</div>
            <div className="cell w-10">세액</div>
            <div className="cell w-7">수량</div>
            <div className="cell w-7">선적기일</div>
          </div>
          {
            taxList?.length > 0 ?
                taxList?.map((item, index) => {
                  return <div className="row" key={index}>
                    <div className="cell" data-title={"세금계산서번호"}>{item.taxNo}</div>
                    <div className="cell" data-title={"품명"}>{item.itemnm}</div>
                    <div className="cell" data-title={"규격"}>{item.itemdeftxt}</div>
                    <div className="cell" data-title={"공급가액"}>{commons.addComma(item.splyAmt)}</div>
                    <div className="cell" data-title={"세액"}>{commons.addComma(item.taxAmt)}</div>
                    <div className="cell" data-title={"수량"}>{item?.itemqty && commons.addComma(item.itemqty)} {item?.itemqtyunitcd}</div>
                    <div className="cell" data-title={"작성일자"}>{ moment(item.writedt).format('Y-M-D') }</div>
                  </div>
                })
                : <div className="row noData"><div className="cell" >등록된 자료가 없습니다.</div></div>
          }
        </div>

        <div className="detail-btn">
          <button className="btn btn-white float-l" onClick={props.doDelete}>삭제</button>
          <button className="btn btn-blue" onClick={() => history.goBack()}>이 전</button>
          <button className="btn btn-blue" onClick={props.goStepNext}>다 음</button>
        </div>
      </React.Fragment>
  )
}

const mapStateToProps = state => {
  return {
    stepData : state.contracter?.data?.step4,
    totalData: state.contracter.data,
    isCalled: state.contracter.isCalled,
  }
}

const actionCreators = {
  setCalled: contracterActions.setCalled,
  alert: contracterActions.alert,
  error: alertActions.error,

}

export default connect(
    mapStateToProps,
    actionCreators
)(CertificateStep04)
